const { request } = require('./apiClient');

function listWorkbooks() {
  return request('/workbook/list').then(function(result) {
    return result && Array.isArray(result.data) ? result.data : [];
  });
}

function createWorkbook(payload) {
  return request('/workbook', {
    method: 'POST',
    body: payload || {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function loadWorkbook(workbookId) {
  return request('/workbook/' + encodeURIComponent(workbookId)).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function renameWorkbook(workbookId, name) {
  return request('/workbook/' + encodeURIComponent(workbookId), {
    method: 'PUT',
    body: { name: String(name || '') }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function deleteWorkbook(workbookId) {
  return request('/workbook/' + encodeURIComponent(workbookId), {
    method: 'DELETE'
  });
}

function addFolder(workbookId, payload) {
  return request('/workbook/' + encodeURIComponent(workbookId) + '/folders', {
    method: 'POST',
    body: payload || {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function renameFolder(workbookId, folderId, name) {
  return request('/workbook/' + encodeURIComponent(workbookId) + '/folders/' + encodeURIComponent(folderId), {
    method: 'PUT',
    body: { name: String(name || '') }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function moveFolder(workbookId, folderId, parentId) {
  return request('/workbook/' + encodeURIComponent(workbookId) + '/folders/' + encodeURIComponent(folderId), {
    method: 'PUT',
    body: { parentId: parentId || null }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function deleteFolder(workbookId, folderId) {
  return request('/workbook/' + encodeURIComponent(workbookId) + '/folders/' + encodeURIComponent(folderId), {
    method: 'DELETE'
  });
}

function moveWorkflow(workflowId, target) {
  var t = target || {};
  return request('/workbook/move-workflow', {
    method: 'PUT',
    body: {
      workflowId: String(workflowId || ''),
      workbookId: String(t.workbookId || ''),
      folderId: String(t.folderId || '')
    }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

module.exports = {
  listWorkbooks: listWorkbooks,
  createWorkbook: createWorkbook,
  loadWorkbook: loadWorkbook,
  renameWorkbook: renameWorkbook,
  deleteWorkbook: deleteWorkbook,
  addFolder: addFolder,
  renameFolder: renameFolder,
  moveFolder: moveFolder,
  deleteFolder: deleteFolder,
  moveWorkflow: moveWorkflow
};
